import moment from "moment";
export var formatLibraryName = function (name, status, formatMessage) {
    if (!name)
        return "";
    if (status === "DELETED") {
        return "".concat(name, " ").concat(formatMessage({
            id: "ui-br-legaldeposits.library.reference.deletedSuffix",
        }));
    }
    return name;
};
export var formatPeriodicalsCount = function (value, noAcceptLabel) {
    return value === 0 ? noAcceptLabel : "".concat(value, "x");
};
export var formatDate = function (dateString) {
    return moment(dateString).format("DD.MM.YYYY");
};
export var formatShortCzechDate = function (isoDate) {
    return moment(isoDate).format("D. M. YYYY");
};
export var formatDateTime = function (isoDate) {
    if (!isoDate)
        return "";
    var date = new Date(isoDate);
    return date.toLocaleDateString("cs-CZ", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};
